//@flow
import { Formik } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Form, Label } from 'reactstrap';
import { userService } from '../../_services/user.service';
import FormSelectInput from '../../components/inputs/FormSelectInput';

type Props = {
  cpf: string,
};

type State = {
  cpf: string,
  userPerfil: any,
};

class SelectPerfilForm extends React.Component<Props, State> {
  formRef: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      cpf: props.cpf || '',
      userPerfil: null,
    };
    this.formRef = null;
  }



  async logar(values) {
    const perfilSelecionado =
      values.userPerfil && values.userPerfil.userRoleId
        ? values.userPerfil.userRoleId
        : 0;


    try {
      await this.props.ssoLogin({
        cpf: values.cpf,
        perfil: perfilSelecionado,
      });
      this.props.history.push('/'); // redireciona se deu bom
    } catch (err) {
      console.error('❌ Falha no login via SSO:', err);
      console.warn('Falha no SSO, erro não tratado:', err);
    }
  }

  render() {
    return (
      <React.Fragment>
        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          enableReinitialize={true}
          initialValues={{
            cpf: this.props.cpf || '',
            userPerfil: null,
          }}
          innerRef={(form) => {
            this.formRef = form;
          }}
          onSubmit={(values) => {

            this.logar(values);
          }}
        >

          {({
            values,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit} autoComplete="off">
              <Label for="senha">Selecione o perfil desejado</Label>
              <FormSelectInput
                name="userPerfil"
                id="userPerfil"
                label=""
                placeholder="Selecione um perfil"
                valueKey="userRoleId"
                labelKey="nomeExibicao"
                noSize={true}
                required={false}
                returnFullObject={true}
                isMulti={false}
                searchable={false}
                allowSelectAll={false}
                service={userService.findUserRolesByCpf}
                onChange={setFieldValue}
                value={values.userPerfil}
                parent={values.cpf}
              />

              <div className="d-flex flex-column-reverse flex-xl-row justify-content-between align-items-center">
                <Button
                  className="bt-size-fixed mt-4 my-xl-4"
                  block={true}
                  color="primary"
                  type="submit"
                >
                  Entrar
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { loggedIn, loginOnline, selectPerfil } = state.authentication;
  const { alert } = state;

  return {
    loggedIn,
    loginOnline,
    alert,
    selectPerfil,
  };
}

const mapDispatch = (dispatch) => ({
  ssoLogin: (cpf, perfilSelecionado) =>
    dispatch.authentication.ssoLogin(cpf, perfilSelecionado),
});


const connectedSelectPerfilForm = connect(
  mapStateToProps,
  mapDispatch
)(withRouter(SelectPerfilForm)); // aqui entra o withRouter

export { connectedSelectPerfilForm as SelectPerfilForm };
